import { Container } from '@pixi/react'
import hs_sound_on_click from '../../../asset/images/menu/music_on_normal.png'
import hs_sound_on_hover from '../../../asset/images/menu/music_on_hover.png'
import hs_sound_on_normal from '../../../asset/images/menu/music_on_normal.png'
import hs_sound_off_click from '../../../asset/images/menu/music_off_click.png'
import hs_sound_off_hover from '../../../asset/images/menu/music_off_hover.png'
import hs_sound_off_normal from '../../../asset/images/menu/music_off_normal.png'

import { Assets } from 'pixi.js'
import { ButtonProps } from './interface/ButtonProps'
import { useEffect, useState } from 'react'
import { Button, Ga4EventType, ga4Info, soundManager, SoundType } from '@slot-nx/core'

Assets.addBundle('HSSoundButton', {
  hs_sound_on_click: { src: hs_sound_on_click, loadParser: 'loadTextures' },
  hs_sound_on_hover: { src: hs_sound_on_hover, loadParser: 'loadTextures' },
  hs_sound_on_normal: { src: hs_sound_on_normal, loadParser: 'loadTextures' },
  hs_sound_off_click: { src: hs_sound_off_click, loadParser: 'loadTextures' },
  hs_sound_off_hover: { src: hs_sound_off_hover, loadParser: 'loadTextures' },
  hs_sound_off_normal: { src: hs_sound_off_normal, loadParser: 'loadTextures' },
})

export const SoundButton = (props: ButtonProps) => {
  const [isMute, setIsMute] = useState(soundManager.isMute())

  useEffect(() => {
    if (isMute) {
      ga4Info.addEvent(Ga4EventType.menu_close_music)
      soundManager.mute()
    }
    else {
      soundManager.unmute()
    }
  }, [isMute])

  const callback = () => {
    const newVal = !isMute
    setIsMute(newVal)
  }

  return (
    <Container position={[props.x, props.y]}>
      {isMute
        ? (
            <Button
              name="sound off Button"
              defaultView="hs_sound_off_normal"
              hoverView="hs_sound_off_hover"
              pressedView="hs_sound_off_click"
              x={0}
              y={0}
              width={props.width}
              height={props.height}
              key="off"
              onPressing={() => {
                soundManager.play(SoundType.buttonConfirm)
              }}
              onPress={callback}
            />
          )
        : (
            <Button
              name="sound on Button"
              defaultView="hs_sound_on_normal"
              hoverView="hs_sound_on_hover"
              pressedView="hs_sound_on_click"
              x={0}
              y={0}
              width={props.width}
              height={props.height}
              key="on"
              onPressing={() => {
                soundManager.play(SoundType.buttonConfirm)
              }}
              onPress={callback}
            />
          )}
    </Container>
  )
}
